import React, { useRef, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { parseCsv } from '../utils/csv';

const { FiUploadCloud } = FiIcons;

function CsvUpload({ columns, onUpload }) {
  const inputRef = useRef(null);
  const [message, setMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  const handleFile = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setMessage('');

    try {
      const rows = parseCsv(await file.text());
      const missing = rows.some((row) => columns.some((column) => !(column in row)));

      if (!rows.length || missing) {
        throw new Error(`CSV must include: ${columns.join(', ')}`);
      }

      await onUpload(rows);
      setMessage(`${rows.length} records imported.`);
    } catch (error) {
      setMessage(error.message);
    } finally {
      setUploading(false);
      event.target.value = '';
    }
  };

  return (
    <div className="csv-upload">
      <div>
        <b>Bulk upload</b>
        <small>Required columns: {columns.join(', ')}</small>
      </div>
      <input ref={inputRef} type="file" accept=".csv,text/csv" onChange={handleFile} />
      <button className="button secondary" onClick={() => inputRef.current?.click()} disabled={uploading}>
        <SafeIcon icon={FiUploadCloud} />
        {uploading ? 'Uploading…' : 'Choose CSV'}
      </button>
      {message && <span className="upload-message">{message}</span>}
    </div>
  );
}

export default CsvUpload;